import type { IDottedBackgroundProps } from '@components/layout/DottedBackground';
import { createContext } from 'react';
import type { Dispatch, ReactNode, SetStateAction } from 'react';

export type PublicLayoutRouteOptions = {
    useMaxWidthWrapper?: boolean;
    dottedBackgroundProps?: IDottedBackgroundProps;
    fullWidthTopContent?: ReactNode;
    /**
     * Enables the search, notifications, and apps features in the public header. Enabled by default.
     */
    enableHeaderFeatures?: boolean;
    extraToolbar?: ReactNode;
    hideSearchBar?: boolean;
    hideChrome?: boolean;
};

export type ActivePublicLayoutOptions = {
    owner: symbol;
    pathname: string;
    options: PublicLayoutRouteOptions;
};

export const PublicLayoutOptionsContext =
    createContext<Dispatch<SetStateAction<ActivePublicLayoutOptions | null>> | null>(null);
